import { TableHead } from '@mui/material';
import axios from 'axios';
import React from 'react'
import { useState } from 'react';
import { Card, Col, Container, Row, Table } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { CheckToken } from '../../login/AccessToken';
import { useEffect } from 'react';
import { ChangeCursor } from './MiscFunctions';
import { toast } from 'react-toastify';

function GetExistingDetails() {
    const { register, handleSubmit, formState: { errors }, setError, getValues } = useForm();
    const [displayExistingDetails, setDisplayExistingDetails] = useState(false)
    const [existingDetails, setExistingDetails] = useState([])
    const [existingDetailsServices, setExistingDetailsServices] = useState([])
    const [authToken, setAuthToken] = useState(sessionStorage.getItem('accessToken') !== undefined && sessionStorage.getItem('accessToken') !== null ? sessionStorage.getItem('accessToken') : "")
    const headers = {
        "Authorization": `Bearer ${authToken}`
    }
    const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
    const history = useHistory()
    useEffect(() => {
        if (sessionStorage.getItem('accessToken') == undefined && sessionStorage.getItem('accessToken') == null) {
            history.push('/login')
        }
    }, [])

    const Token = () => {
        const check = CheckToken()
        setAuthToken(sessionStorage.getItem('accessToken'))
        return check
    }

    const getServicesDetails = (data, e) => {
        e.preventDefault()
        ChangeCursor()
        if (Token()) {
            // console.log(data);
            axios.get(`${REACT_APP_BACKEND_ROUTE_URL}get_registered_facilities/`, {
                headers: headers
            })
                .then((res) => {
                    console.log(res)
                    setExistingDetails(res.data.bridge)
                    setExistingDetailsServices(res.data.services)
                    setDisplayExistingDetails(true)
                    ChangeCursor()
                })
                .catch((err) => {
                    console.log(err)
                    toast.error(err)
                    ChangeCursor()
                })
        }
    };
    const navigate = (e) => {
        history.push(`/${e.target.id}`)
    }
    return (
        <div>
            <h1 style={{ paddingLeft: '35%' }}>Get Existing Details</h1>
            <Container>
                <Row style={{ marginTop: "2%", marginbottom: "2%", paddingBottom: '2%', width: '125%', marginLeft: '-10%' }} >
                    <Col >
                        <Card onClick={(e) => navigate(e)} id='register_patient' style={{ width: '100%', marginLeft: '-30%', height: '100%', cursor: 'pointer' }} >
                            <div style={{ display: "flex" }} id='register_patient' >
                                <img id='register_patient' src="/img/success-black-check-mark.svg" alt="" />
                                <h6 id='register_patient' style={{ paddingTop: '10%', whiteSpace: 'nowrap' }}>
                                    Register Patient
                                </h6>
                            </div>
                        </Card>
                    </Col>
                    <Col >
                        <Card onClick={(e) => navigate(e)} id='care_context' style={{ width: '140%', marginLeft: '-35%', height: '100%', cursor: 'pointer' }}>
                            <div style={{ display: "flex" }} id='care_context'>
                                <img src="/img/success-black-check-mark.svg" id='care_context' alt="" />
                                <h6 id='care_context' style={{ paddingTop: '8%', whiteSpace: 'nowrap' }}>
                                    Create & Link Visit Purpose
                                </h6>
                            </div>
                        </Card>
                    </Col>
                    {sessionStorage.getItem('subscription_type') !== undefined && sessionStorage.getItem('subscription_type') !== null
                        && sessionStorage.getItem('subscription_type').includes("Connector/Adaptor") ?
                        []
                        :
                        <Col >
                            <Card onClick={(e) => navigate(e)} id='upload_report' style={{ width: '100%', height: '100%', cursor: 'pointer' }}>
                                <div style={{ display: "flex" }} id='upload_report'>
                                    <img id='upload_report' src="/img/success-black-check-mark.svg" alt="" />
                                    <h6 id='upload_report' style={{ paddingTop: '10%', whiteSpace: 'nowrap' }}>
                                        Upload Report
                                    </h6>
                                </div>
                            </Card>
                        </Col>
                    }
                    <Col >
                        <Card onClick={(e) => navigate(e)} id='consent' style={{ width: '100%', height: '100%', cursor: 'pointer' }}>
                            <div style={{ display: "flex" }} id='consent'>
                                <img id='consent' src="/img/success-black-check-mark.svg" alt="" />
                                <h6 id='consent' style={{ paddingTop: '10%', whiteSpace: 'nowrap' }}>
                                    EHR Data Access
                                </h6>
                            </div>
                        </Card>
                    </Col>
                    <Col >
                        <Card onClick={(e) => navigate(e)} id='admin_services' style={{ width: '100%', height: '100%', cursor: 'pointer' }}>
                            <div style={{ display: "flex" }} id='admin_services'>
                                <img id='admin_services' src="/img/success-black-check-mark.svg" alt="" />
                                <h6 id='admin_services' style={{ paddingTop: '10%', whiteSpace: 'nowrap' }}>
                                    Admin Services
                                </h6>
                            </div>
                        </Card>
                    </Col>
                    <Col >
                        <Card onClick={(e) => navigate(e)} id='scan_qr' style={{ width: '100%', height: '100%', cursor: 'pointer' }} >
                            <div style={{ display: "flex" }} id='scan_qr' >
                                <img id='scan_qr' src="/img/success-black-check-mark.svg" alt="" />
                                <h6 id='scan_qr' style={{ paddingTop: '10%', whiteSpace: 'nowrap' }}>
                                    QR
                                </h6>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <div className="col-sm-12 col-md-12 col-lg-7" style={{ marginLeft: '22%' }}>
                <div className="contact-panel mb-50">
                    <form className="contact-panel__form" onSubmit={handleSubmit(getServicesDetails)}>
                        <div className="row">
                            <div className="col-12">
                                <button type="submit" className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10">
                                    <span>Get Existing Details</span> <i className="icon-arrow-right"></i>
                                </button>
                                <div className="contact-result"></div>
                            </div>
                        </div>
                    </form>

                    {displayExistingDetails ?
                        <div style={{ paddingTop: "3%" }}>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <i className="icon-news form-group-icon"></i>
                                    <input type="text" className="form-control" defaultValue={existingDetails !== undefined ? existingDetails.id : ""} placeholder='Facility ID' name="facility_id" readOnly
                                        {...register("facility_id", {
                                            required: "Facility ID is required.",
                                        })} />
                                    {errors.facility_id && (
                                        <p className="errorMsg">{errors.facility_id.message}</p>
                                    )}
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <input type="text" className="form-control" defaultValue={existingDetails !== undefined ? existingDetails.name : ""} placeholder='Facility Name' name="facility_name" readOnly
                                        {...register("facility_name", {
                                            required: "Facility Name is required.",
                                        })} />
                                    {errors.facility_name && (
                                        <p className="errorMsg">{errors.facility_name.message}</p>
                                    )}
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group">
                                    <input type="text" className="form-control" defaultValue={existingDetails !== undefined ? existingDetails.url : ""} placeholder='Facility Address' name="facility_address" readOnly
                                        {...register("facility_address", {
                                            required: "Facility Address is required.",
                                        })} />
                                    {errors.facility_address && (
                                        <p className="errorMsg">{errors.facility_address.message}</p>
                                    )}
                                </div>
                            </div>
                            <div >
                                <h1>Facility List</h1>
                                <Table bordered responsive size="lg" >
                                    <TableHead style={{ display: 'grid', fontWeight: 'bold', gridTemplateColumns: '145px 145px 145px 145px 155px' }}>
                                        <th>Id</th>
                                        <th>Name</th>
                                        <th>Type</th>
                                        <th>EndPoint</th>
                                        <th>IsActive</th>
                                    </TableHead>
                                    <tbody>
                                        {existingDetailsServices.map((item, index) => (
                                            <td style={{ display: 'grid', gridTemplateColumns: '145px 145px 145px 145px 125px' }}>
                                                <tr>{item.id}</tr>
                                                <tr>{item.name}</tr>
                                                <tr>{item.types.join(" , ")}</tr>
                                                <tr>{item.endpoints.length > 0 ? item.endpoints : ""}</tr>
                                                <tr>{item.active}</tr>
                                                {/* {item.active === true ?
                                                    <tr style={{ color: 'green', fontWeight: 'bold' }}>{item.active}</tr>
                                                    :
                                                    <tr style={{ color: 'red', fontWeight: 'bold' }}>{item.active}</tr>
                                                } */}
                                            </td>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                        :
                        []
                    }
                </div>
            </div>
        </div>
    )
}

export default GetExistingDetails